import { browser, Logger } from '@kulee/helper'

// 环境
export const ENV = (process.env.SDP_ENV || 'development') as EnvType

// 是否是在SDK下运行
export const KULEWEBVIEW = browser.version.kuleWebview
// 移动端
export const MOBILE = browser.version.mobile
export const MOBILE_IOS = browser.version.ios
export const MOBILE_ANDROID = browser.version.android

export const KULEWEBVIEW_ANDROID = KULEWEBVIEW && MOBILE_ANDROID
// export const KULEWEBVIEW_ANDROID = true
export const KULEWEBVIEW_IOS = KULEWEBVIEW && MOBILE_IOS
// 日志前缀
export const LOGGER_PREFIX = 'PAGE'
// 日志输出等级
export const LOGGER_LEVEL = Logger.LEVEL.INFO

// stripe支付网关公钥
export const STRIPE_PUBLIC_KEY =
  ENV === 'development' || ENV === 'test'
    ? 'pk_test_51RthSEBgm3suDIq82QXpV8JbVwtAxzwBdcJA0cCQyaTqaE3VjXR8VFZIHTEiSqpn7NwIKduJCQIdsz9TDYTX7rOJ00M4B34Xyk'
    : 'pk_live_51RthRzBCp9GQuSq87GwcI9TOnPRjGuddGPadIGdmF9r6YxKBYqzpaHkPRFiU795BFrmKIEOhRLA0vODjRXOEKNCg00zXEMOtr5'

// 历史游戏本地存储KEY
export const RECENT_GAME_LOCAL_STOAGE_KEY = 'tga-recent-games'
// 历史游戏本地存储上限个数
export const RECENT_GAME_MAX = 60
// 对战游戏用户最长离线时间
export const PKGAME_USER_MAX_OFFLINE_TIME = 10 * 1000

// react-query keys
export const QUERY_KEYS = {
  // 首页推荐游戏列表
  GAME_COLLECTION: 'game/collection',
  // 游戏列表
  GAME_LIST: 'game/game-list',
  // 智能推荐游戏-根据用户
  GAME_RECOMMEND_BYUSER_LIST: 'game/recommend/byuser/games',
  // 智能推荐游戏-根据游戏
  GAME_RECOMMEND_BYGAME_LIST: 'game/recommend/bygame/games',
  // 带标签游戏列表
  GAME_TGAGAMES_LIST: 'game/tags/games',
  // 游戏详情
  GAME_DETAIL: 'game/detail',
  // 标签列表
  TAG_LIST: 'tag/list',
  // 标签详情
  TAG_DETAIL: 'tag/detail',
  // 签到列表
  CHECKINS: 'checkin/data',
  // 签到状态
  CHECKIN_STATUS: 'checkin/status',
  // 任务列表
  TASKS: 'task/data',
  // 任务列表
  TASKS_STATUS: 'task/status',
  // 成就列表
  ACHIEVEMENTS: 'achievement/data',
  // 对战游戏配置
  PK_GAME_CONFIG: 'pkgame/config',
  // 对战游戏状态
  PK_GAME_STATUS: 'pkgame/status',
  // 排行榜
  RANK_CONFIG: 'rank/config',
  // 钱包充值商品列表
  WALLET_CHARGE_COMMODITY: 'wallet/charge-commodity',
  // 封面列表
  COVER_LIST: 'uc/cover-list',
  // 头像列表
  AVATAR_LIST: 'uc/avatar-list',
  // 邀请奖励配置
  INVITE_REWARD_CONFIG: 'invite/reward-config'
}

export const EVENT_NAMESPACE = {
  POPUP: 'popup'
}
